module.exports = __webpack_public_path__ + "img/master.a21c6a7f.png";